
export function buildGoogleStaticMapUrl(geoLocations){
    let GOOGLE_STATIC_MAP_URL = "https://maps.googleapis.com/maps/api/staticmap?"
    
    // Add size param
    GOOGLE_STATIC_MAP_URL += "size=512x512&"
  
      let locations = ""; 
      if(geoLocations.length == 1){
        // Set the zoom to Landmass/continent if there is only one geolocation
        // Otherwise, use default zoom for locations.
        // The following list shows the approximate level of detail you can expect to see at each zoom level: 
        // 1: World, 5: Landmass/continent, 10: City, 15: Streets, 20: Buildings
        GOOGLE_STATIC_MAP_URL += "zoom=5&";
      }
      for(const i in geoLocations){
        const lat = geoLocations[i]["lat"];
        const lng = geoLocations[i]["lng"];
        if(lat && lng){
          if(locations !== ""){
              // Add pipe to separate path points
              locations += "|"
          }
          locations += `${lat},${lng}`;
        }
      }
      GOOGLE_STATIC_MAP_URL += `markers=${locations}&path=${locations}&key=AIzaSyBLATi3dXQgilPg_CdhLq7xYQqZV4bcnkg`;
  
      return GOOGLE_STATIC_MAP_URL;
}